import {
Card,
CardBody,
CardHeader,
CardFooter,
Container, 
Row,
Form,
Col,
FormGroup,
Button,
Alert,
Input,
Dropdown,
DropdownItem,
DropdownToggle,
DropdownMenu,
Modal,
Label,
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import React, { useState, useEffect }  from 'react';
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from 'axios';
import { ReactSession } from 'react-client-session';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { DateTime } from 'luxon'
import 'react-loading-skeleton/dist/skeleton.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const CreateOrder = () => {
    // Deffining state functinality, page behaves differently according to these
    const [customer, setCustomer] = useState([]);
    const BASE_URL = process.env.REACT_APP_BASE_URL
    let [customerRole, setRole] = useState('')
    let [loading, setLoading] = useState(true)
    // Customer State
    let [students, setStudents] = useState([])
    let [selectedStudent, setStudent]  = useState('')
    let [studentSelected, setStudentSelected] = useState(false)
    let [studentsOpen, setStudentsOpen] = useState(false)
    let [cardsOpen, setCardsOpen] = useState(false)
    let [selectedCard, setCard] = useState(null)
    //
    let [drinks, setDrinks] = useState([])
    let [snacks, setSnacks] = useState([])
    // Product State
    let [products, setProducts] = useState([])
    let [productsOpen, setProdOpen] = useState(false)
    let [selectedProduct, setProduct] = useState({ product: null })
    let [productSelected, setProductSelected] = useState(false)
    let [productName, setProductName] = useState('')
    let [snackName, setSnackName] = useState('')
    let [drinkName, setDrinkName] = useState('')
    let [modsOpen, setModsOpen] = useState(false)
    let [selectedMod, setMod] = useState([])
    //
    let [drinkSelected, setDrinkSelected] = useState(false)
    let [selectedDrink, setDrink] = useState({ drink: null })
    let [snackSelected, setSnackSelected] = useState(false)
    let [selectedSnack, setSnack] = useState({ snack: null })
    let [bagTotal, setBagTotal] = useState(0)
    // Alert stuff
    let [creatingOrder, setCreatingOrder] = useState(false)
    let [alertSuccess, setSuccessAlert] = useState(false)
    let [alertError, setAlertError] = useState(false)
    let [alertErrorMessage, setAlertMessage] = useState('')
    let [startDate, setStartDate] = useState(new Date());
    let [emptyCart, setEmptyCart] = useState('')
    //
    let [instructions, setInstruction] = useState('')
    let [kidMessage, setKidMessage] = useState('')
    // Cart stuff
    let [cart, setCart] = useState({
        id: null,
        cartMeals: [],
        sub_total: '0.00',
        cart_total: '0.00',
        current_tax: '0.00',
        credit: '0.00'
    })
    let [subTotal, setSubTotal] = useState(0)
    let [lateFee, setFee] = useState(0)
    let [total, setTotal] = useState(0)
    let [creditApplied, setCredit] = useState(0)
    let [chargeAmount, setChargeAmount] = useState(0)
    let [receiverRole, setReceiverRole] = useState('')
    let [deleteCartMealModal, setModalOpen] = useState(false)
    let [mealIDOnDelete, setMealID] = useState(0)
    const { id } = useParams();
    const { handleSubmit, register, control } = useForm();

    // About the isLate state
    let [isLate, setIsLate] = useState(true)

    const token = ReactSession.get("token");
    let config = {
      headers: {
        'Authorization': `Bearer ${token}` 
      }
    }
    
    // Helper: resolve schoolId from either a student object or a teacher (customer.parent)
    const resolveSchoolId = (entity) => {
        if (!entity) return null
        // Student shape
        if (entity.schoolId) return entity.schoolId
        if (entity.school && entity.school.id) return entity.school.id
        // Teacher shape (admin customer has parent relation)
        if (entity.parent && entity.parent.schoolId) return entity.parent.schoolId
        if (entity.parent && entity.parent.school && entity.parent.school.id) return entity.parent.school.id
        return null
    }

    // Helper: format any numeric or string amount as currency with 2 decimals
    const formatMoney = (val) => {
        if (val === null || val === undefined) return '0.00'
        const num = typeof val === 'number' ? val : parseFloat(val)
        if (isNaN(num)) return '0.00'
        return num.toFixed(2)
    }
  
    const createOrder = async () => {
      
        if (cart.cartMeals.length === 0) {
             setEmptyCart('Your cart is empty.')
        } else {
            setCreatingOrder(true)
            setLoading(true)
            try {
                let res = await axios.post(BASE_URL + '/orders/create', {cartID: cart.id, isLate: isLate}, config)
                if (res.status === 200) {
                    getCart()
                    setSuccessAlert(true)
                    setCreatingOrder(false)
                    setLoading(false)
                }
            } catch (error) {
                console.log(error.response)
                if (error.response && error.response.data.message) {
                    setAlertMessage(error.response.data.message)
                } else {
                    setAlertMessage('There was an error creating your order.')
                }
                setAlertError(true)
                setCreatingOrder(false)
                setLoading(false)
            }
        
        }
    }

    const getProducts = async (student) => {
        // Build the URL with the schoolId if available (works for students and teachers)
        let url = `${BASE_URL}/product/admin?name=${productName}`
        const schoolId = resolveSchoolId(student)
        if (schoolId) {
            url += `&schoolId=${schoolId}`
        }

        let res = await axios.get(url, config) 
        if (res.status === 200) {
            let prods = filterAllergies(res.data)
            // Ensure each product has the correct price
            prods = prods.map(product => {
                // If there are prices by school and there is at least one, use the first one
                if (product.productPricesBySchool && product.productPricesBySchool.length > 0) {
                    return {
                        ...product,
                        originalPrice: product.price, // Save the original price
                        price: product.productPricesBySchool[0].price // Use the school-specific price
                    }
                }
                return product
            })
            setProducts(prods)
        }
    }

    const filterAllergies = (itemList) => {
        // Compare student allergies vs each product allergy 
        // if student or customer is allergic should not return the product as available.
        let studentAllergies = selectedStudent ? selectedStudent.allergies.map((alg) => alg.id) : []
        let finalList = []
        itemList.forEach((item) => {
            let itemAlgs = item.allergies.map((alg) => alg.id)
            let isItemAllergicToCustomer = itemAlgs.some(i => studentAllergies.includes(i))
            if (!isItemAllergicToCustomer) {
                finalList.push(item)
            } 
        })
        return finalList
    }

    const getCustomerInfo = async () => {
        let data = await axios.get(BASE_URL + '/customers/' + id, config)
        setCustomer(data.data)
        // Ensure each student has an ID to use as a key
        if (data.data && data.data.parent && data.data.parent.students) {
            const studentsWithIds = data.data.parent.students.map((student, index) => {
                // If no ID, assign a unique index
                if (!student.id) {
                    return { ...student, id: `temp-student-${index}` };
                }
                return student;
            });
            setStudents(studentsWithIds);
        } else {
            setStudents([]);
        }
        console.log('data', data.data)
        setRole(data.data.role)
        setLoading(false)
    }


    const getDrinks = async () => {
        try {
            let res = await axios.get(BASE_URL + '/addons/drinks/admin?name=' + drinkName, config)
            let filteredDrinks = filterAllergies(res.data)
            setDrinks(filteredDrinks)
            return res.data;
        } catch (error) {
            console.error("Error fetching drinks:", error)
            return [];
        }
    }

    const getSnacks = async () => {
        try {
            let res = await axios.get(BASE_URL + '/addons/snacks/admin?name=' + snackName, config)
            let filteredSnacks = filterAllergies(res.data)
            setSnacks(filteredSnacks)
            return res.data;
        } catch (error) {
            console.error("Error fetching snacks:", error)
            return [];
        }
    }

    const selectProduct = (pr) => {
        let newProduct = pr
        setProduct({ product: newProduct })
        setProductSelected(true)
        // calculatePrice()
    }

    const selectSnack = (sn) => {
        let newSnack = sn
        setSnack({snack: newSnack})
        setSnackSelected(true)
        // calculatePrice()
    }
    
    const selectDrink = (dr) => {
        let newDrink = dr
        setDrink({ drink: newDrink })
        setDrinkSelected(true)
        // calculatePrice()
    }

    const selectModfifier = (mod) => {
        selectedMod.push(mod)
        setMod(selectedMod)
        calculatePrice()
    }

    const selectPM = async (card) => {
        try {
            setLoading(true)
            // Ensure we have a valid cart id before making the request
            if (!cart || !cart.id) {
                await getCart()
            }
            if (!cart || !cart.id) {
                setAlertMessage('Cart is not ready yet. Please add an item or wait until the cart loads, then try again.')
                setAlertError(true)
                return
            }

            // Optimistic UI update so selection sticks immediately
            setCard(card)
            setCardsOpen(false)

            const pmId = Number(card.id)
            await axios.put(BASE_URL + '/cart/' + cart.id + '/pm/' + pmId + '/admin', {
                userId: customer.userId
            }, config)
            // Refresh cart to ensure backend state is reflected
            await getCart()
        } catch (err) {
            console.error('Error selecting payment method:', err)
            const msg = err?.response?.data?.message || err?.response?.data?.error || 'Failed to set payment method.'
            setAlertMessage(msg)
            setAlertError(true)
        } finally {
            setLoading(false)
        }
    }

    const getCart = async () => {
        let res = await axios.get(BASE_URL + '/cart/' + id + '/admin', config)
        if (res.status === 200) {
            // Ensure each meal in the cart has a unique ID
            if (res.data && res.data.cartMeals) {
                const cartWithIds = {
                    ...res.data,
                    cartMeals: res.data.cartMeals.map((meal, index) => {
                        if (!meal.id) {
                            return { ...meal, id: `temp-meal-${index}` };
                        }
                        return meal;
                    })
                };
                setCart(cartWithIds);
            } else {
                setCart(res.data);
            }
            setSubTotal(res.data.sub_total)
            setTotal(res.data.cart_total)
            setCredit(res.data.credit)
            setChargeAmount(parseFloat(res.data.cart_total - res.data.credit))
            setCard(res.data.lastPaymentUsed)
        } else {
            setCart({
                id: null,
                cartMeals: [],
                sub_total: '0.00',
                cart_total: '0.00',
                current_tax: '0.00',
                credit: '0.00'
            })
        }
    }

    const getLateFee = async ()  => {
        try {
            const res = await axios.get(BASE_URL + "/settings/latefee", config)
            if (res.status === 200) {
                const fee = (res.data ?? '0.00')
                setFee(isLate ? fee : '0.00')
            } else {
                setFee('0.00')
            }
        } catch (error) {
            console.error("Error fetching late fee:", error)
            setFee('0.00')
        }
    }

    // Update late fee whenever isLate changes without refetching other heavy data
    useEffect(() => {
        getLateFee()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLate])

    const clearForm = () => {
        setStudent('')
        setStudentSelected(false)
        setProduct({ product: null })
        setProductSelected(false)
        setSnack({ snack: null })
        setSnackSelected(false)
        setDrink({ drink: null })
        setDrinkSelected(false)
        setMod([])
        setInstruction('')
        setKidMessage('')
        // Clear the list of products when clearing the form
        setProducts([])
    }
    const addToCart = async () => {
        if (
            selectedStudent &&
            selectedProduct.product
            && selectedDrink.drink
            && selectedSnack.snack
            && selectedMod.length >= 0) {
                let modIds = selectedMod.map((mod) => mod.id)
                //  Plus one becase this functions return from 0 to 11 January being 0
                //  Day being the same thing
                const [month, day, year] = [(startDate.getMonth() + 1).toString(),( startDate.getDate()).toString(), startDate.getFullYear()];
                let monthDate = month.length === 1 ? '0' + month : month 
                let  dayDate = day.length === 1 ? '0' + day : day
                let deliveryDate = year.toString() + '-' +  monthDate  + '-' + dayDate
                // Determine the effective schoolId for pricing (student or teacher)
                const schoolId = resolveSchoolId(selectedStudent)
                let cartMealContent = {
                    customerId: Number(id),
                    receiverRole: receiverRole,
                    receiverId: Number(selectedStudent.id),
                    productId: Number(selectedProduct.product.id),
                    drinkId: Number(selectedDrink.drink.id),
                    snackId: Number(selectedSnack.snack.id),
                    mealDate: deliveryDate,
                    instructions: instructions,
                    message: kidMessage,
                    modifiers: modIds,
                    // Send schoolId so backend applies school-specific pricing (including teacher orders)
                    schoolId: schoolId,
                }

                try {
                    setLoading(true)
                    const response = await axios.post(BASE_URL + '/cart/create', cartMealContent, config)
                    
                    // First update the cart to ensure we have the latest data
                    await getCart()
                    
                    // Show success message to the user
                    setSuccessAlert(true)
                    
                    // Save a copy of the current values to prevent errors when clearing the form
                    const currentProduct = {...selectedProduct};
                    const currentSnack = {...selectedSnack};
                    const currentDrink = {...selectedDrink};
                    const currentMods = [...selectedMod];
                    
                    // Clear the form with a small delay to allow React to process
                    setTimeout(() => {
                        clearForm()
                        setLoading(false)
                    }, 300)
                } catch (error) {
                    console.error("Error adding item to cart:", error)
                    const msg = error?.response?.data?.message || error?.response?.data?.error || "Failed to add item to cart. Please try again."
                    setAlertMessage(msg)
                    setAlertError(true)
                    setLoading(false)
                } 
        } else {
            // Missing info
            let message = ''
            if (!selectedProduct.product) {
                message += '\n Please make sure to select a product.\n'
            }
            if (!selectedStudent) {
                message += '\n Please make sure to select a student.\n\n'
            }
            if (!selectedDrink.drink) {
                message += '\n Please select your lunchbag drink.\n'
            }
            if (!selectedSnack.snack) {
                message += '\n Please select your lunchbag snack.\n'
            }
            setAlertMessage(message)
            setAlertError(true)
        }
    }

    const selectStudent = (student) => {
        setStudent(student)
        setStudentSelected(true)
        setReceiverRole('student')
        setStudentsOpen(false)
        // Load products with the student's schoolId
        getProducts(student)
    }

    const selectCustomer = (customer) => {
        setStudent(customer)
        setStudentSelected(true)
        setReceiverRole('teacher')
        setStudentsOpen(false)
        // Load products with teacher's schoolId for school-specific pricing
        getProducts(customer)
    }

    

    const calculatePrice = () => {
        // Protection against null values in the selected product
        let productPrice = 0
        if (productSelected && selectedProduct && selectedProduct.product && selectedProduct.product.price) {
            productPrice = parseFloat(selectedProduct.product.price)
        }
        
        // Protection against null values in modifiers
        let totalMods = 0
        if (selectedMod && Array.isArray(selectedMod)) {
            selectedMod.forEach(mod => {
                if (mod && mod.price) {
                    totalMods += parseFloat(mod.price)
                }
            })
        }
        
        // Protection against null values in snacks
        let snackPrice = 0
        if (selectedSnack && selectedSnack.snack && selectedSnack.snack.price) {
            snackPrice = parseFloat(selectedSnack.snack.price)
        }
        
        // Protection against null values in drinks
        let drinkPrice = 0
        if (selectedDrink && selectedDrink.drink && selectedDrink.drink.price) {
            drinkPrice = parseFloat(selectedDrink.drink.price)
        }
        
        let currentTotal = productPrice + totalMods + snackPrice + drinkPrice

        setBagTotal(currentTotal.toFixed(2))
    }

    const deleteCartMeal = async () => {
        setModalOpen(false)
         await axios.put(BASE_URL + '/cart/remove/meal' ,
        { mealID: mealIDOnDelete }, config
        )
        getCart()
    }



    useEffect(() => {
        let isMounted = true;
        
        const loadData = async () => {
            try {
                if (isMounted) {
                    await getProducts(selectedStudent);
                    await getSnacks();
                    await getDrinks();
                }
            } catch (error) {
                console.error("Error loading data:", error);
            }
        };
        
        loadData();
        
        // Cleanup function to prevent updates in unmounted components
        return () => {
            isMounted = false;
        };
    }, [selectedStudent, productName, snackName, drinkName])


    useEffect(() => {
        let isMounted = true;
        
        const loadInitialData = async () => {
            try {
                if (!creatingOrder && isMounted) {
                    await getCustomerInfo();
                    calculatePrice(); // This function is synchronous
                    await getLateFee();
                    await getCart();
                }
            } catch (error) {
                console.error("Error loading initial data:", error);
            }
        };
        
        loadInitialData();
        
        // Cleanup function to prevent updates in unmounted components
        return () => {
            isMounted = false;
        };
    }, [
        loading,
        bagTotal, 
        selectedProduct,
        selectedMod,
        selectedSnack,
        selectedDrink,
        isLate,
        startDate,
        id
    ])
     
    if (loading) {
        return (
        <>
        <UserHeader></UserHeader>
        <Container fluid className="mt--7">
        <Row className='align-items-center justify-content-center'>
        <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                    <h3 className="mb-0">Create New Order</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                   
                    </Col>
                </Row>
            </CardHeader>
            <CardBody >
              <SkeletonTheme
                    baseColor="#5294e0"
                    highlightColor="#96c7ff"
                    borderRadius="0.5rem"
                    duration={4}
                >
            </SkeletonTheme>
              <Skeleton count={10} width="100%"/>
            </CardBody>
        </Card>
        </Row>
    </Container>
        </>
        )
    } else return (
    <>
    <UserHeader></UserHeader>
    <Container fluid className="mt--7">
        <Alert color="success" isOpen={alertSuccess}  fade={true} toggle={(e) => setSuccessAlert(false)}>
              Order Created!
        </Alert>
        <Alert color="danger" isOpen={alertError}  fade={true} toggle={(e) => setAlertError(false)}>
            {alertErrorMessage}
        </Alert>
        <Row className='align-items-start justify-content-center'>
        <Col lg='8'>
        <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                    <h3 className="mb-0">Create New Order</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                    <h3 className="mb-0">Total: ${formatMoney(bagTotal)}</h3>

                    {/* <h4>Category: {product.category.name}</h4> */}
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
            <Form onSubmit={handleSubmit(addToCart)}>
            <Row>
            <Col lg='8'>
                <FormGroup>
                    <label
                        className="form-control-label"
                        htmlFor="input-students"
                    >
                    Student
                    </label>
                    <br></br>
                    <Dropdown toggle={() => setStudentsOpen(!studentsOpen)} isOpen={studentsOpen}>
                        <DropdownToggle>
                            {selectedStudent
                            ? `${selectedStudent.first_name} ${selectedStudent.last_name}`
                            : 'Select a student'}
                        </DropdownToggle>
 
                            <DropdownMenu>
                                {customerRole === 'teacher' ? (
                                /* ────────── TEACHER VIEW ────────── */
                                <>
                                    {/* Show any students they do have */}
                                    {students.map((student, index) => (
                                    <div key={`student-${student.id}-${index}`}>
                                        <DropdownItem onClick={() => selectStudent(student)}>
                                        {student.first_name} {student.last_name}
                                        </DropdownItem>
                                    </div>
                                    ))}

                                    {/* Always show “Yourself” */}
                                    <div key={`customer-${customer.id || 'self'}`}>
                                    <DropdownItem onClick={() => selectCustomer(customer)}>
                                        Yourself&nbsp;<small>(only for teachers)</small>
                                    </DropdownItem>
                                    </div>
                                </>
                                ) : (
                                /* ────────── NON-TEACHER VIEW ────────── */
                                <>
                                    {students.length > 0 ? (
                                    students.map((student, index) => (
                                        <div key={`student-${student.id}-${index}`}>
                                        <DropdownItem onClick={() => selectStudent(student)}>
                                            {student.first_name} {student.last_name}
                                        </DropdownItem>
                                        </div>
                                    ))
                                    ) : (
                                    <DropdownItem disabled>No students available</DropdownItem>
                                    )}
                                </>
                                )}
                            </DropdownMenu>
                        </Dropdown>

                    </FormGroup>
                </Col>
                <Col lg='4'>
                        <label
                            className="form-control-label"
                            htmlFor="input-students"
                        >
                        Select A Date
                        </label>
                        <br></br>
                    <DatePicker selected={startDate} onChange={(date) => {
                        setStartDate(date)
                    }}
                    className='form-control'
                    />
                </Col>
            </Row>
                <Row>
                    <Col lg='6'>
                    <label
                        className="form-control-label"
                        htmlFor="input-first-name"
                    >
                    Select a product    
                    </label>
                    <br></br>
                    <Dropdown toggle={() => setProdOpen(!productsOpen)} isOpen={productsOpen} flip={'true'} >
                       <Row className='px-2'>
                            <DropdownToggle disabled={!studentSelected}>
                            {selectedProduct.product ? <span>{selectedProduct.product.name} ${formatMoney(selectedProduct.product.price)}</span>:  <Input disabled={!studentSelected} onChange={(e) => setProductName(e.target.value)} placeholder="Search for a product" />}
                            </DropdownToggle>
                            {productSelected && <Button onClick={() => {
                                setProductSelected(false)
                                setProduct({product: null})
                                setMod([])
                                calculatePrice()
                            }}><i className='ni ni-fat-remove'></i></Button>}
                        </Row>
                        <DropdownMenu>
                            {/* Just display a list of 9 products */}
                            {products.length > 0 ? (
                                <>
                                    {products.slice(0,8).map((prod, index) => (
                                        <div key={`product-${prod.id}-${index}`}>
                                            <DropdownItem onClick={() => selectProduct(prod)}>{prod.name} ${formatMoney(prod.price)}
                                                {prod.originalPrice && 
                                                    <span style={{fontSize: '0.8em', color: 'green', marginLeft: '5px'}}>
                                                        (School Price)
                                                    </span>
                                                }
                                            </DropdownItem>
                                        </div>
                                    ))}
                                    <div key="more-products">
                                        <DropdownItem>Search to find more...</DropdownItem>
                                    </div>
                                </>
                            ) : (
                                <DropdownItem disabled>No products available</DropdownItem>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                    </Col>
                    <Col lg='6'>
                    <label
                        className="form-control-label"
                        htmlFor="input-first-name"
                    >
                    Select your Modifiers    
                    </label>
                    <br></br>
                    <Dropdown toggle={() => {
                        if (productSelected) {
                            setModsOpen(!modsOpen)
                        }
                    }} isOpen={modsOpen}>
                        <DropdownToggle>
                        { selectedProduct.product ? selectedMod.length > 0 ? <ul className='p-0 mx-2 my-0'>{selectedMod.map((mod, index) => <li key={`mod-item-${mod.id}-${index}`}>{mod.name} ${formatMoney(mod.price)}</li>)}</ul> :<span>Select a modifier</span>: <span>Choose your product before selecting a modifier</span>}
                        </DropdownToggle>
                        <DropdownMenu>
                            {selectedProduct.product && selectedProduct.product.modifiers ? (
                                selectedProduct.product.modifiers.filter(mod => !selectedMod.includes(mod)).map((mod, index) => (
                                    <div key={`mod-${mod.id}-${index}`}>
                                        <DropdownItem onClick={() => selectModfifier(mod)}>{mod.name} ${formatMoney(mod.price)}</DropdownItem>
                                    </div>
                                ))
                            ) : (
                                <DropdownItem disabled>No modifiers available</DropdownItem>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                    </Col>
                </Row>
                <br></br>
                <Row>
                    <Col lg='6'>
                    <label
                        className="form-control-label"
                        htmlFor="input-first-name"
                        >
                    Select a Snack    
                    </label>
                    <br></br>
                    <Dropdown toggle={() => {
                            setSnackSelected(!snackSelected)
                    }} isOpen={snackSelected}>
                        <DropdownToggle disabled={!studentSelected}>
                        { selectedSnack.snack ? <span>{selectedSnack.snack.name} - ${formatMoney(selectedSnack.snack.price)}</span>: <Input disabled={!studentSelected} onChange={(e) => setSnackName(e.target.value)} placeholder="Search for a snack" />}
                        </DropdownToggle>
                        <DropdownMenu>
                            {snacks.length > 0 ? (
                                <>
                                    {snacks.map((snack, index) => (
                                    <div key={`snack-${snack.id}-${index}`}>
                                        <DropdownItem onClick={(e) => {
                                            e.preventDefault()
                                            selectSnack(snack)
                                        }}>{snack.name} - ${formatMoney(snack.price)}</DropdownItem>
                                    </div>
                                    ))}
                                    <div key="more-snacks">
                                        <DropdownItem>Search to find more...</DropdownItem>
                                    </div>
                                </>
                            ) : (
                                <DropdownItem disabled>No snacks available</DropdownItem>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                    </Col>
                    <Col lg='6'>
                    <br></br>
                    <Dropdown toggle={() => {
                            setDrinkSelected(!drinkSelected)
                    }} isOpen={drinkSelected}>
                        <DropdownToggle disabled={!studentSelected}>
                        { selectedDrink.drink ? <span>{selectedDrink.drink.name} - ${formatMoney(selectedDrink.drink.price)}</span>: <Input disabled={!studentSelected} onChange={(e) => setDrinkName(e.target.value)} placeholder="Search for a drink" />}
                        </DropdownToggle>
                        <DropdownMenu>
                            {drinks.length > 0 ? (
                                <>
                                    {drinks.map((drink, index) => (
                                    <div key={`drink-${drink.id}-${index}`}>
                                        <DropdownItem onClick={() => selectDrink(drink)}>{drink.name} - ${formatMoney(drink.price)}</DropdownItem>
                                    </div>
                                    ))}
                                    <div key="more-drinks">
                                        <DropdownItem>Search to find more...</DropdownItem>
                                    </div>
                                </>
                            ) : (
                                <DropdownItem disabled>No drinks available</DropdownItem>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                    </Col>
                </Row>
                <br></br>
                <Row>
                    <Col  md='10' lg='6' >
                    <FormGroup>
                        <label
                            className="form-control-label"
                            htmlFor="input-instructions"
                        >
                        Lunch Instructions
                        </label>
                        <br></br>
             
                    <Input 
                                value={instructions}
                                onChange={(e) => setInstruction(e.target.value)}
                               type='textarea'
                               rows='5'
                               cols='40'
                            ></Input>
                    </FormGroup>
                    </Col>
                    <Col md='10' lg='6' >
                    <FormGroup>
                        <label
                        className="form-control-label"
                        htmlFor="input-meal-message"
                        >
                        Kid's Message
                        </label>
                        <br></br>
                        <Input 
                               value={kidMessage}
                               onChange={(e) => setKidMessage(e.target.value)}
                               type='textarea'
                               rows='5'
                               cols='40'
                            ></Input>
                    </FormGroup>
                    </Col>
                </Row>
                <Row className='pl-3'>
                    <Button color='primary' onClick={() => addToCart()}> Add To Cart</Button>
                </Row>
            </Form>
            </CardBody>
        </Card>
        </Col>
        <Col lg='4'>
            <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center justify-content-between">
                    <Col xs="4">
                    <h3 className="mb-0">Cart</h3>
                    </Col>
                    <Col className="text-right" xs="6">
                    {/* <h4>Category: {product.category.name}</h4> */}
                    <Label check>
                    <Input type="checkbox" checked={isLate} onChange={(e) => setIsLate(e.target.checked)}></Input>
                        Is customer late ?
                    </Label>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <Row className='justify-content-between'>
                <Col lg='4'>
                    <label
                        className="form-control-label"
                        htmlFor="input-first-name"
                        >
                        Name
                    </label>
                    <br></br>
                    <span>{customer.first_name} {customer.last_name}</span>
                </Col>
                <hr />
                <Col lg='6'>
                    <FormGroup>
                    <label
                        className="form-control-label"
                        htmlFor="input-first-name"
                    >
                        Payment Method
                    </label>
                    <Dropdown toggle={() => setCardsOpen(!cardsOpen)} isOpen={cardsOpen}>
                        <DropdownToggle disabled={!cart || !cart.id}>
                            { selectedCard ? <span> {selectedCard.brand} - {selectedCard.last4}</span>  : <span>Select a payment Method</span>}
                        </DropdownToggle>
                        <DropdownMenu>
                        {
                            customer.wallet.paymentMethods && customer.wallet.paymentMethods.map((card) => (
                                <div key={`card-${card.brand}-${card.last4}`}>
                                    <DropdownItem active={!!selectedCard && card.id === selectedCard.id} onClick={() => selectPM(card)}>{card.brand} - {card.last4}</DropdownItem>
                                </div>
                            ))
                        }
                        </DropdownMenu>
                    </Dropdown>
                    </FormGroup>
                </Col>
                </Row>
            {customerRole === 'teacher' ? <span className='' style={{'color': 'green'}}>
             30% Teacher Discount Automatically Applied
                </span> : null}
            <hr className='py-2 my-2'></hr>
            <div>

            {cart && cart.cartMeals.map((cartMeal, index) => {
                return (
                    <Card key={`meal-${cartMeal.id || index}`} className='shadow my-2'>
                    <CardBody className='p-4'>
                        <Row className='justify-content-between'>
                            <Col>
                            {cartMeal.receiver_name} 
                            </Col>
                    
                            <Row className='px-4 align-items-center justify-content-between'>
                            ${formatMoney(cartMeal.sub_total)}
                            <Col>
                            </Col>
                            <Button size="sm" color='danger' onClick={(e) => {
                                setModalOpen(true)
                                setMealID(cartMeal.id)
                            }}><i className='ni ni-fat-remove' /></Button>
                            </Row>
                        </Row>
                        <hr className='p-0 my-2'/>
                        <Row className='px-3 justify-content-between'>
                        {cartMeal.product.name} 
                        <span>
                        {Intl.DateTimeFormat('en-US').format(DateTime.fromSQL(cartMeal.delivery_date))}
                        </span>
                        </Row>
                        <Row className='px-3'>
                        {cartMeal.drink && cartMeal.drink.name ? cartMeal.drink.name : 'No drink'} - {cartMeal.snack && cartMeal.snack.name ? cartMeal.snack.name : 'No snack'}
                        </Row>
                        {cartMeal.modifiers && cartMeal.modifiers.length > 0 && (
                            <Row className='px-3'>
                                <span>Modifiers: </span>
                                {cartMeal.modifiers.map((mod, index) => (
                                    <React.Fragment key={`cart-mod-${mod.id || index}-${cartMeal.id || 'unknown'}`}>
                                        <span>{mod.name}</span>
                                        {index < cartMeal.modifiers.length - 1 && <span>, </span>}
                                    </React.Fragment>
                                ))}
                            </Row>
                        )}
                    </CardBody>
                </Card>
                )
            })}
            </div>
            </CardBody>
            <CardFooter>
                <Row>
                    <Col>
                        <p>SubTotal: ${formatMoney(subTotal)}</p>
                        <p>Tax : ${formatMoney(cart.current_tax)}</p>
                        <p>Late Fee: ${formatMoney(lateFee)}</p>
                        <p>Total: ${formatMoney(parseFloat(total) + parseFloat(lateFee))}</p>
                    </Col>
                    <Col>
                        <p>Credit Applied: ${formatMoney(creditApplied)}</p>
                        <p>Charge amount: ${formatMoney(parseFloat(total) + parseFloat(lateFee) - parseFloat(creditApplied))}</p>
                       
                    </Col>
                </Row>
                <Row className='justify-content-between align-items-center pr-4 pl-4'>
                    <Button color='primary' onClick={() => createOrder()}> Submit </Button>
                    {emptyCart ?? <span>{emptyCart}</span>}
                </Row>
            </CardFooter>
            </Card>
        </Col>
        </Row>
        <Modal
        isOpen={deleteCartMealModal} 
        className="modal-dialog-centered"
        size="sm"
        >
            <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                        <p>Are you sure you want to delete this cart meal?</p>
                        <Row className='justify-content-center align-items-center'>
                            <Button onClick={() => setModalOpen(false)}>
                                No
                            </Button>
                            <Button color='danger' onClick={() => deleteCartMeal()}>
                                Yes
                            </Button>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        </Modal>
    </Container>
    </>
    )
}
export default CreateOrder